<template>
  <div class="cars">
    <Car
      v-for="(car, index) in cars"
      :key="`car-${index}`"
      :car="car"
      tabindex="0"
      class="cars__car"
      @select="$emit('select', $event)"
    />
  </div>
</template>

<script>
  import Car from '@/components/Cars/Car'

  export default {
    name: 'Cars',
    components: {
      Car
    },
    props: {
      cars: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss">
.cars {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: flex-start;

  &__car {
    flex-basis: 320px;
    margin-bottom: 60px;

    &:not(:nth-of-type(3n)) {
      margin-right: 40px;
    }

    @include tablet {
      margin-bottom: 40px;

      &:not(:nth-of-type(3n)) {
        margin-right: 0;
      }

      &:not(:nth-of-type(2n)) {
        margin-right: 40px;
      }
    }

    @include mobile {
      flex-basis: 100%;
      margin-bottom: 40px;

      &:not(:nth-of-type(3n)) {
        margin-right: 0;
      }

      &:not(:nth-of-type(2n)) {
        margin-right: 0;
      }
    }

    img {
      left: 0;
    }
  }
}
</style>
